<app-work-order-filter-bar
  [isDayView]="selectedView == 'day'"
  [typeOfWorkOrders]="'wellness'"
  [allWorkOrders]="allWorkOrders"
  [rms]="rms"
  [equipmentTypes]="equipmentTypes"
  (OnWoFilteringFinished)="OnWoFilteringFinished($event)"
  [useSearchDelay]="false"
  >
</app-work-order-filter-bar>

<p-panel header="" class="innerHeader">
  <div style="text-align: center;">
    <app-loading-swirly [isLoading]="isLoading"></app-loading-swirly>
  </div>

  <div class="p-grid">
    @for (bigDayBucket of filteredBigDayBuckets; track bigDayBucket) {
      <app-multiday-job-card class="cdk-drag p-lg-4 p-md-12"
        [bigDayBucket]="bigDayBucket" [type]="'wellness'">
      </app-multiday-job-card>
    }
  </div>
</p-panel>